export const subscriptionQueryKeys = {
  all: [{ scope: 'subscription' }] as const,
  mySubscription: () =>
    [{ ...subscriptionQueryKeys.all[0], entity: 'subscription' }] as const,
};

export const podcastPromoQueryKeys = {
  all: [{ scope: 'podcast-promo' }] as const,
  myCredits: () =>
    [{ ...podcastPromoQueryKeys.all[0], entity: 'credits' }] as const,
};
